<div *ngIf="toast" class="toast-container" [ngClass]="toast.type">
  <div class="toast-icon">
    <i *ngIf="toast.type === 'success'" class="bi bi-check-circle-fill"></i>
    <i *ngIf="toast.type === 'error'" class="bi bi-exclamation-triangle-fill"></i>
  </div>
  <div class="toast-content">
    <h4>{{ toast.type === 'success' ? 'Success' : 'Error' }}</h4>
    <p>{{ toast.message }}</p>
  </div>
</div>
